<div class="resources-selection-container">
    <div class="dialog-title-section">
        <h2 class="dialog-title">{{ 'permit.create.resources.title' | translate }}</h2>
        <p class="dialog-subtitle">{{ 'permit.create.resources.subtitle' | translate }}</p>
    </div>

    <div class="resources-list">
        <div class="resource-item" *ngFor="let file of files">
            <button
                type="button"
                class="resource-icon"
                [attr.aria-label]="('permit.create.resources.open' | translate) + ' ' + fileName(file)"
                (click)="openFile(file)"
            >
                <img *ngIf="isPdf(file)" src="assets/images/pdf-file.svg" alt="PDF" />
                <img *ngIf="isWord(file)" src="assets/images/word-file.svg" alt="Word" />
                <img *ngIf="isExcel(file)" src="assets/images/sheets-file.svg" alt="Excel" />
                <mat-icon *ngIf="!isPdf(file) && !isWord(file) && !isExcel(file)">insert_drive_file</mat-icon>
            </button>

            <div class="resource-content">
                <h3 class="resource-name">{{ fileName(file) }}</h3>
                <p class="resource-description" *ngIf="fileDescription(file) as description">{{ description }}</p>
            </div>

            <div class="resource-actions">
                <button
                    type="button"
                    class="resource-action-btn"
                    [attr.aria-label]="('permit.create.resources.open' | translate) + ' ' + fileName(file)"
                    (click)="openFile(file)"
                >
                    <i class="icon-view"></i>
                </button>
                <a
                    class="resource-action-btn resource-action-btn--download"
                    [attr.href]="fileUrl(file)"
                    [attr.aria-label]="('permit.create.resources.download' | translate) + ' ' + fileName(file)"
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <mat-icon>download</mat-icon>
                </a>
            </div>
        </div>
    </div>
</div>
